import React from 'react';
import {
  Button, Form, Image, Upload,
} from 'antd';
import {
  UploadOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import translations from '../../hooks/translation/translations.json';

function FileInput({
  label, name, errorMessage, accept = '', rules = [], form,
}) {
  const files = Form.useWatch(name);

  return (
    <div>
      <Form.Item
        name={name}
        label={label}
        validateStatus={errorMessage && 'error'}
        help={errorMessage}
        rules={rules}
      >
        <Upload
          listType="picture"
          maxCount={1}
          beforeUpload={() => false}
          accept={accept}
          fileList={[]}
        >
          <Button icon={<UploadOutlined />}>
            {translations.ka.choose_file}
          </Button>
        </Upload>
      </Form.Item>
      {files?.fileList
          && files.fileList?.map((file) => (
            <div className="flex gap-5 items-center my-5">
              <Image
                alt={file?.name}
                src={file?.originFileObj ? URL.createObjectURL(file.originFileObj) : `/${file?.url}`}
              />
              <DeleteOutlined onClick={() => form.resetFields([name])} />
            </div>
          ))}
    </div>
  );
}

export default FileInput;
